export const onBoardingStatus = {
  REGISTERED: 'registered',
  STORE_CONNECTED: 'store_connected',
  QUESTIONNAIRE_COMPLETED: 'questionnaire_completed',
};

const { hostname } = window.location;
// eslint-disable-next-line no-nested-ternary
export const env = (hostname.indexOf('dev') > -1 || hostname.includes('test')) ? 'dev' : (hostname.indexOf('localhost') > -1 ? 'local' : 'prod');

export const PREFILLED_SHOP_DOMAIN_KEY = 'PREFILLED_SHOP_DOMAIN_ON_CONNECTION_PAGE';

export * from './api';
export * from './policy';
export * from './storage';
export * from './img';

export default {
  onBoardingStatus,
  env,
};

/** 邮箱地址 */
export const EmailAddress = {
  Seel: 'merchant@seel.com',
  Support: 'support@seel.com',
};

// 所有产品的名称map
export const PRODUCT_NAME = {
  RETURN_ASSURANCE: 'Return Assurance',
  BUYER_PROTECTION: 'Buyer Protection',
  SHIPPING_PROTECTION: 'Shipping Protection',
  GREEN_SHIPPING_PROTECTION: 'Green Shipping Protection',
  BUYBACK_GUARANTEE: 'Buyback Guarantee',
  EXTENDED_WARRANTY: 'Extended Warranty',
  INSTANT_REFUND: 'Instant Refund',
  GUARANTEED_DELIVERY_DATE: 'Guaranteed Delivery Date',
  ESTIMATED_DELIVERY_DATE: 'Estimated Delivery Date',
  ASSURED_SALE: 'Assured Sale',
  DELIVERY_GUARANTEE: 'Delivery Guarantee',
};

export const STYTCH_PUBLIC_TOKEN = env === 'prod' ? 'public-token-live-e9f1ce8c-eebe-4f0a-a63d-bfced5dde086' : 'public-token-test-898dd57c-c285-452f-a205-b77793f9e1da';
export const STYTCH_PROJECT_ID = 'project-live-e0966f46-3ab0-40ba-95a8-3d7e0373b838';
export const STYTCH_SECRET = 'secret-live-77W7lgj-W58Lpd6ZxZPOXmQu7TSIgE-6aww=';
